export default __webpack_public_path__ + "static/media/OkCupid.3ba5db21.png";